import Vue from "vue";
import Vuex from "vuex";
import createAccount from "./modules/createAccount";
import common from "./modules/common";
import failReason from "./modules/failReason";
import network from "./modules/network";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    createAccount,
    common,
    failReason,
    network
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
});
